import State from 'store/State';
import { selectStrategyParametersState } from 'widgets/strategyParams/store/selectors';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useSelector } from 'react-redux';

export const selectStrategyParametersConfiguration = (
    state: State,
    widgetKey: string
) => {
    const widgetState = selectStrategyParametersState(state, widgetKey);
    return widgetState && widgetState.config ? widgetState.config : {};
};

export const useStrategyParametersConfigSelector = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) =>
        selectStrategyParametersConfiguration(state, widgetKey)
    );
};
